module.exports = __webpack_public_path__ + "img/Skridsko_akare.7200b0c9.jpg";